import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./i18n"; // initializes react-i18next (side-effect import)
import "./theme/tailwind.css"; // Tailwind base/components/utilities (must load before tokens)
import "./theme/tokens.css"; // the design-token contract

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
